import { readingModes } from "@/mocks/comicGuide";

export default function ReadingModes() {
  return (
    <section id="modes" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-xs text-secondary-900">
            <i className="ri-exchange-line text-sm"></i>
            阅读方式
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl text-foreground-900">
            四种方式，任你切换
          </h2>
          <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600">
            每种模式都针对不同的阅读场景做了优化，在阅读设置里随时切换，找到最顺手的那一种。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {readingModes.map((mode) => (
            <article
              key={mode.title}
              className="group flex flex-col rounded-lg bg-background-50 p-5 transition-colors hover:bg-background-50/70 border border-background-200"
            >
              <div className="flex items-start justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className={`${mode.icon} text-2xl`}></i>
                </span>
                <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-1 text-xs text-accent-900">
                  {mode.tag}
                </span>
              </div>
              <h3 className="mt-4 text-lg font-bold text-foreground-900">{mode.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{mode.desc}</p>
              <ul className="mt-4 space-y-2 border-t border-background-200 pt-4">
                {mode.points.map((p) => (
                  <li key={p} className="flex items-start gap-2 text-xs text-foreground-700">
                    <i className="ri-checkbox-circle-line text-accent-500 mt-0.5 text-sm"></i>
                    {p}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}